import { CallAPI } from "../../apiManager/ApiCall";
import { demoRequestURL } from "apiManager/APIConfig";

/** Admin: list demo requests — GET /api/demo-request */
export const GetDemoRequestsCall = async () => {
  try {
    const response = await CallAPI({
      url: demoRequestURL,
      method: "GET",
    });
    if (response?.success && Array.isArray(response?.data)) {
      return {
        rows: response.data,
        statuses: Array.isArray(response.statuses) ? response.statuses : null,
      };
    }
    return { rows: [], statuses: null };
  } catch (error) {
    return { rows: [], statuses: null };
  }
};

/** Admin: PATCH /api/demo-request/:id */
export const UpdateDemoRequestStatusCall = async (id, status) => {
  try {
    const response = await CallAPI({
      url: `${demoRequestURL}/${id}`,
      method: "PATCH",
      body: { status },
    });
    return response?.success ? response : null;
  } catch (error) {
    return null;
  }
};

/** Admin: DELETE /api/demo-request/:id */
export const DeleteDemoRequestCall = async (id) => {
  try {
    const response = await CallAPI({
      url: `${demoRequestURL}/${id}`,
      method: "DELETE",
    });
    return response?.success ? response : null;
  } catch (error) {
    return null;
  }
};
